export const StringProp = { type: String, default: null };
export const NumProp = { type: Number, default: 0 };
export const BoolProp = (defaultValue = false) => ({ type: Boolean, default: defaultValue });
export const ObjProp = () => ({
    type: Object,
    default: () => ({}),
});
export const ArrProp = () => ({
    type: Array,
    default: () => [],
});
export const EnumProp = (d, e) => ({
    type: [String, Number],
    default: d,
    validator: (v) => e[v] !== undefined,
});
